import { Asset, ModelID, SearchParams } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'asset_id' | 'asset_type_id' | 'name';
export interface AssetSearchParams extends SearchParams<Filter, Sort>, Partial<Asset> {
  with_status?: boolean;
}

export const featurePath = '/v4/equipment/asset';

export const featureKeys = {
  all: [{ scope: 'asset' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: AssetSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
